import { gettext } from '@eventbrite/i18n';
import React from 'react';

type Artist = {
    name: string;
};

type ArtistList = Artist[];

export type PerformersProps = {
    headliners?: ArtistList;
    supporters?: ArtistList;
};

const _getArtists = (artists: ArtistList) =>
    artists.map(({ name }: Artist) => name).join(', ');

export const Performers = ({
    headliners = [],
    supporters = [],
}: PerformersProps = {}) => {
    if (!headliners.length && !supporters.length) {
        return null;
    }

    return (
        <>
            <h3 className="label-primary eds-l-mar-bot-2">
                {gettext('Performers')}
            </h3>

            <div className="event-details__data">
                <div className="eds-g-cell eds-g-cell-12-12 has-user-generated-content">
                    {headliners.length > 0 && (
                        <p className="text-stressed">
                            {_getArtists(headliners)}
                        </p>
                    )}
                    {supporters.length > 0 && <p>{_getArtists(supporters)}</p>}
                </div>
            </div>
        </>
    );
};
